<template>
  <div id="app">
    <div align="center">
      <img src="../assets/inscora-logo-principal.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    showMessage() {
      this.$store.state.progress = false
      this.$store.state.dialogError = true
    }
  },
  created() {
    this.$store.dispatch('findCatalogByType', 'CIIU')
  }


}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width: 100px) {
  img {
    width: 50%;
    height: 50%;
  }
}

@media (min-width: 500px) {
  img {
    width: 25%;
    height: 25;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Start.vue